import { c as _c } from "react/compiler-runtime";
import { useSubscribedCoupon } from './useSubscribedCoupon.js';
/**
 * Gets outcome array for given board and event.
 *
 * @param root0 function args
 * @param root0.couponId Unique id of the coupon
 * @param root0.couponIndex Specific coupon id in order
 * @param root0.eventNumber Event number in the sequence
 * @param root0.groupIndex Event group index, mainly used for result
 * @param root0.boardIndex Used for multiple board bets, like SROW
 * @returns Coupon event outcomes array
 */
export function useCouponOutcomes(t0) {
  const $ = _c(8);
  const {
    couponId,
    couponIndex,
    boardIndex: t1,
    eventNumber,
    groupIndex
  } = t0;
  const boardIndex = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== boardIndex || $[1] !== eventNumber || $[2] !== groupIndex) {
    t2 = coupon => {
      const board = coupon?.boards[boardIndex];
      if (!board) {
        return [];
      }
      if (groupIndex !== undefined && eventNumber) {
        return board.outcomes[eventNumber - 1]?.[groupIndex] ?? [];
      }
      if (eventNumber) {
        return board.outcomes[eventNumber - 1] ?? [];
      }
      return board.outcomes;
    };
    $[0] = boardIndex;
    $[1] = eventNumber;
    $[2] = groupIndex;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== couponId || $[5] !== couponIndex || $[6] !== t2) {
    t3 = {
      couponId,
      couponIndex,
      selector: t2
    };
    $[4] = couponId;
    $[5] = couponIndex;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const outcomes = useSubscribedCoupon(t3);
  return outcomes;
}